import axios from "axios";

export const login = ({ email, password, currency, brandId }) =>
  axios.post("/api/v2/auth/login", {
    email,
    password,
    currency,
    brand_id: brandId
  });

export const getUser = token =>
  axios.get("/api/v2/player", {
    headers: {
      Authorization: "Bearer " + token
    }
  });

export const register = ({
  brandId,
  username,
  lang,
  oddsFormat,
  email,
  password,
  expireIn
}) =>
  axios.post("/api/v2/auth/reg", {
    brand_id: brandId,
    username,
    lang,
    odds_format: oddsFormat,
    email,
    password,
    expire_in: expireIn
  });

export const getBalance = () => axios.get("/api/v2/player/assets");

export const addMoney = (amount, currency) =>
  axios.post("/api/v2/player/top-up", {
    amount,
    currency
  });

export const getThemes = () =>
  axios.get(process.env.THEMES_URL).then(res => res.data);

export const getEnvs = () =>
  axios
    .get("https://environments-api.k8s1-beta-htz.devspt.com/api/v1/environments/")
    .then(res => res.data);

export const updateToken = data => {
  const payload = {
    ...data
  };
  if (payload.lang) {
    payload.lang = new Intl.Locale(data.lang).baseName;
  }

  return axios.patch(`/api/v2/auth/token`, payload);
};

export const getBrands = envName =>
  axios.get(
    `https://environments-api.k8s1-beta-htz.devspt.com/api/v1/environments/${envName}/brands`
  );
